import { useState, useRef, useCallback, useEffect } from "react";

export const useScrollManagement = (currentChat, isTyping) => {
  const chatBoxRef = useRef(null);
  const chatEndRef = useRef(null);
  const [lastScrollHeight, setLastScrollHeight] = useState(null);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const isAtBottomRef = useRef(true);

  const scrollToBottom = useCallback((behavior = "smooth") => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior });
      isAtBottomRef.current = true;
      setShowScrollButton(false);
    }
  }, []);

  const handleScroll = useCallback((event, loadMoreMessages, loading, hasMoreMessages) => {
    const chat = event.target;

    if (chat.scrollTop < 50 && !loading && hasMoreMessages) {
      loadMoreMessages();
    }
    const atBottom = chat.scrollHeight - chat.scrollTop - chat.clientHeight < 120;
    isAtBottomRef.current = atBottom;
    setShowScrollButton(!atBottom);
  }, []);

  useEffect(() => {
    if (!chatBoxRef.current || !chatEndRef.current) return;

    const chatBox = chatBoxRef.current;
    const isNearBottom = chatBox.scrollHeight - chatBox.scrollTop - chatBox.clientHeight < 200;
    isAtBottomRef.current = isNearBottom;
    setShowScrollButton(!isNearBottom);

    if (isNearBottom || isTyping) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
      isAtBottomRef.current = true;
      setShowScrollButton(false);
    }

    if (lastScrollHeight !== null && chatBox.scrollTop < 100) {
      const newScrollHeight = chatBox.scrollHeight;
      const heightDiff = newScrollHeight - lastScrollHeight;
      chatBox.scrollTop = heightDiff;
    }
  }, [currentChat?.messages, isTyping, lastScrollHeight]);

  useEffect(() => {
    setLastScrollHeight(null);
    setShowScrollButton(false);
    isAtBottomRef.current = true;

    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "auto" });
    }
  }, [currentChat?._id]);

  return {
    chatBoxRef,
    chatEndRef,
    showScrollButton,
    setShowScrollButton,
    scrollToBottom,
    handleScroll,
    setLastScrollHeight,
    isAtBottomRef
  };
};

